/* import __COLOCATED_TEMPLATE__ from './ipa-keyboard.hbs'; */
/* RESPONSIBLE TEAM: team-fin-voice */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import {
  type KeyboardType,
  type KeyboardTab,
  getSymbolsForTab,
  getTabsForType,
} from './ipa-keyboard-data';

interface Signature {
  Args: {
    type: KeyboardType;
    onInsertSymbol: (symbol: string) => void;
  };
  Element: HTMLElement;
}

export default class IpaKeyboard extends Component<Signature> {
  @service declare intl: IntlService;

  @tracked selectedTab: KeyboardTab | null = null;

  get validTabs(): KeyboardTab[] {
    return getTabsForType(this.args.type);
  }

  get activeTab(): KeyboardTab {
    let valid = this.validTabs;
    if (this.selectedTab && valid.includes(this.selectedTab)) {
      return this.selectedTab;
    }
    return valid[0];
  }

  get tabs(): { id: KeyboardTab; label: string }[] {
    return this.validTabs.map((id) => ({
      id,
      label: this.intl.t(`ai-agent.voice-playground.ipa-keyboard.tab-${id}`),
    }));
  }

  get currentSymbols(): string[] {
    return getSymbolsForTab(this.args.type, this.activeTab);
  }

  @action
  setActiveTab(tabId: KeyboardTab) {
    this.selectedTab = tabId;
  }

  @action
  insertSymbol(symbol: string) {
    this.args.onInsertSymbol(symbol);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::VoicePlayground::IpaKeyboard': typeof IpaKeyboard;
    'ai-agent/voice-playground/ipa-keyboard': typeof IpaKeyboard;
  }
}
